export enum ImoShipTypeEnum {
    Unknown,
    One,
    Two,
    Three,
}
